import Vue from "vue"
import VueRouter from "vue-router"
import Layout from "../components/layout"
import Dashboard from "../views/Dashboard.vue"
import Blog from "../views/Blog.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: "/blog",
        name: "Blog",
        component: Blog,
      },
    ],
  },
]

const router = new VueRouter({
  routes,
  mode: "hash",
})

export default router
